import preferences from './module';
import { Feature } from '@common-stack/server-core';

export default new Feature(preferences);
